import updateExerciseAction from 'modules/training/modules/training-exercises/actions/update'
import { EXERCISE_KEY } from 'modules/training/models/exercise/constants'

function updateNameExerciseAction (instance, value) {
  return updateExerciseAction({
    key: EXERCISE_KEY.NAME,
    value,
    instance
  })
}

export default updateNameExerciseAction
